import { useEffect } from "react"
import { options } from "../utils/tmdbToken"
import { useDispatch, useSelector } from "react-redux"
import { videoTrailer } from "../utils/movieSlice"

const useVideo=(movieId)=>{
     
    
    
        
    
    const dispatch=useDispatch()
   
   
    useEffect(()=>{
        fetchVideo()
    },[])
    const fetchVideo=async()=>{
        if(!movieId) return   
        const data= await fetch(`https://api.themoviedb.org/3/movie/${movieId}/videos?language=en-US`,options)
        const video=await data.json()
        
        
        const filter=video.results && video.results.filter((video)=>video.name==="Official Trailer")
       
        //const trailer=filter.length?filter[0]:filter?.results[0]
       
        
        dispatch(videoTrailer(filter))
        
    }
}
export default useVideo
